import { render, staticRenderFns } from "./ChatMessagesComponent.vue?vue&type=template&id=423cfa84&"
import script from "./ChatMessagesComponent.vue?vue&type=script&lang=js&"
export * from "./ChatMessagesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lpcms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('423cfa84')) {
      api.createRecord('423cfa84', component.options)
    } else {
      api.reload('423cfa84', component.options)
    }
    module.hot.accept("./ChatMessagesComponent.vue?vue&type=template&id=423cfa84&", function () {
      api.rerender('423cfa84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ChatMessagesComponent.vue"
export default component.exports